import type { AdvancedSearchWrapperProps } from "./components/AdvancedSearchWrapper";
import type * as lazyIndex from "./lazyIndex";
import { type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "AdvancedSearchModule" */ "./lazyIndex"), {
    name: "AdvancedSearchModule",
});

export const AdvancedSearchWrapper: LazyComponent<AdvancedSearchWrapperProps, unknown, void> = createLazyComponent(lazyModule, m => m.AdvancedSearchWrapper);
